import { z } from "zod";

export const personalDataSchema = z.object({
    nomeCompleto: z.string().min(1, "Nome completo é obrigatório."),
    cpf: z.string().min(1, "CPF é obrigatório.").refine(
        (val) => {
            let cpf = val.replace(/[.-]/g, "");
            if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
            let sum = 0, remainder;
            for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
            remainder = (sum * 10) % 11;
            if (remainder === 10 || remainder === 11) remainder = 0;
            if (remainder !== parseInt(cpf.substring(9, 10))) return false;
            sum = 0;
            for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
            remainder = (sum * 10) % 11;
            if (remainder === 10 || remainder === 11) remainder = 0;
            if (remainder !== parseInt(cpf.substring(10, 11))) return false;
            return true;
        },
        { message: "CPF inválido." }
    ),
    rg: z.string().min(1, "RG é obrigatório."),
    email: z.string().min(1, "E-mail é obrigatório.").email("E-mail inválido."),
    data_nascimento: z.string().min(1, "Data de nascimento é obrigatória."),
    telefone: z.string().refine((val) => val.replace(/\D/g, "").length === 11, {
        message: "O telefone deve ter 11 dígitos.",
    }),
    estadoCivil: z.string().min(1, "Estado civil é obrigatório."),
    nome_conjuge: z.string().optional(),
    cpf_conjuge: z.string().optional(),
}).superRefine((data, ctx) => {
    if (data.estadoCivil === "Casado(a)") {
        if (!data.nome_conjuge || !data.nome_conjuge.trim()) {
            ctx.addIssue({ path: ["nome_conjuge"], message: "Nome do cônjuge é obrigatório.", code: z.ZodIssueCode.custom });
        }
        if (!data.cpf_conjuge) {
            ctx.addIssue({ path: ["cpf_conjuge"], message: "CPF do cônjuge é obrigatório.", code: z.ZodIssueCode.custom });
        } else {
            const digits = data.cpf_conjuge.replace(/\D/g, "");
            if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) {
                ctx.addIssue({ path: ["cpf_conjuge"], message: "CPF do cônjuge inválido.", code: z.ZodIssueCode.custom });
            }
        }
    }
});

export const addressSchema = z.object({
    logradouro: z.string().min(1, "Logradouro é obrigatório."),
    numero: z.string().min(1, "Número é obrigatório."),
    bairro: z.string().min(1, "Bairro é obrigatório."),
    cep: z.string().regex(/^\d{5}-?\d{3}$/, "CEP inválido."),
    cidade: z.string().min(1, "Cidade é obrigatória."),
    estado: z.string().regex(/^[A-Z]{2}$/i, "Estado (UF) inválido."),
});

export const bankDataSchema = z.object({
    nomeBanco: z.string().min(1, "Nome do banco é obrigatório."),
    agencia: z.string().min(1, "Agência é obrigatória."),
    conta: z.string().min(1, "Conta é obrigatória."),
    tipoConta: z.string().min(1, "Tipo de conta é obrigatório."),
    tipoPix: z.string().optional(),
    chavePix: z.string().optional(),
}).superRefine((data, ctx) => {
    if (data.tipoPix && data.chavePix) {
        if (data.tipoPix === "cpf") {
            // Simplified validation check inside zod
            let val = data.chavePix;
            let cpf = val.replace(/[.-]/g, "");
            if (cpf.length !== 11) {
                ctx.addIssue({ path: ["chavePix"], message: "Chave PIX (CPF) inválida.", code: z.ZodIssueCode.custom });
            }
        }
        if (data.tipoPix === "email" && !/.+@.+\..+/.test(data.chavePix)) {
            ctx.addIssue({ path: ["chavePix"], message: "Chave PIX (E-mail) inválida.", code: z.ZodIssueCode.custom });
        }
        if (data.tipoPix === "telefone" && data.chavePix.replace(/\D/g, "").length !== 11) {
            ctx.addIssue({ path: ["chavePix"], message: "Chave PIX (Telefone) inválida.", code: z.ZodIssueCode.custom });
        }
    }
});
